import initialState from './initialState';
import createReducer from './createReducer';
import Immutable from 'immutable';

const addTransactionLog = (state, action) => {
    return state.set('logs', state.get('logs').push(Immutable.fromJS(action.log)));
};

const rehydrate = (state, action) => {
    if (action.payload.transactionLog) {
        state = action.payload.transactionLog;
    }
    return state.set('stateReady', true);
};

const setTransactionLogSendStarted = (state) => {

    return state.set('logsSending', true);

};

const setTransactionLogSendFinished = (state) => {

    return state.set('logsSending', false);

};

const setTransactionLogSendFailed = (state) => {

    return state.set('logsSending', false);

};

const handlers = {
    'ADD_TRANSACTION_LOG': addTransactionLog,
    'TRANSACTION_LOG_SEND_STARTED': setTransactionLogSendStarted,
    'TRANSACTION_LOG_SEND_FINISHED': setTransactionLogSendFinished,
    'TRANSACTION_LOG_SEND_FAILED': setTransactionLogSendFailed,
    'persist/REHYDRATE': rehydrate
};

export default createReducer(initialState.get('transactionLog'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/transactionLogReducer.js